import { ANNOUNCEMENT_TYPE } from "../../../services/flitEnum";

export const searchAnnouncementsMockData = [
  {
    id: 1,
    title: "Flit Update",
    type: ANNOUNCEMENT_TYPE.UPDATE,
    message:
      "We have exciting news for our users! A new patch is coming on 12/12/2025. This update includes several bug fixes and performance improvements, along with new features that you've been asking for. We're always working hard to make our platform better for you, and we believe this new patch will enhance your user experience considerably. Remember to update your Flit app to the newest version on the release date. Stay tuned for more details as we get closer to the release date!",
    createdBy: 534,
    createdOn: "2025-08-07T10:09:00.000Z",
    lastUpdatedBy: 534,
    submittedById: 534,
    lastUpdatedOn: "2025-08-07T10:09:00.000Z",
  },
  {
    id: 2,
    title: "System Maintenance",
    type: ANNOUNCEMENT_TYPE.MAINTENANCE,
    message:
      "Dear users, we would like to inform you about a scheduled downtime on 08/15/2025 from 2AM to 4AM. This is part of our regular system maintenance to ensure the most secure, efficient, and smooth service. You will not be able to access our platform during this period. We apologize for any inconvenience this might cause and thank you for your understanding and patience.",
    createdBy: 512,
    createdOn: "2025-08-06T09:00:00.000Z",
    lastUpdatedBy: 512,
    submittedById: 599,
    lastUpdatedOn: "2025-08-06T09:00:00.000Z",
  },
  {
    id: 3,
    title: "New Feature Release",
    type: ANNOUNCEMENT_TYPE.FEATURE,
    message:
      "We're thrilled to announce the release of a brand-new feature to enhance your usage experience. Our development team has been working tirelessly to create this innovative feature based on valuable feedback from users like you. We encourage you to try it out and let us know your thoughts. Our team is always looking for ways to improve and serve you better, and your feedback is critical to achieving that objective. Thank you for your continued support of our platform.",
    createdBy: 587,
    createdOn: "2025-08-05T14:30:00.000Z",
    lastUpdatedBy: 587,
    submittedById: 568,
    lastUpdatedOn: "2025-08-05T14:30:00.000Z",
  },
  {
    id: 4,
    title: "User Feedback Survey",
    type: ANNOUNCEMENT_TYPE.FEEDBACK,
    message:
      "Hello, dear users. We're conducting a user feedback survey and we really want to hear from you. Share your thoughts on our platform and help us make it better by 08/20/2025. Follow the link in the dashboard to participate in the survey. Your insights are valuable in helping us to improve and provide the best possible service to all users. Let's shape the future of our platform together!",
    createdBy: 555,
    createdOn: "2025-08-04T11:15:00.000Z",
    lastUpdatedBy: 555,
    submittedById: 541,
    lastUpdatedOn: "2025-08-04T11:15:00.000Z",
  },
  {
    id: 5,
    title: "Security Update",
    type: ANNOUNCEMENT_TYPE.SECURITY,
    message:
      "We have an important security update. It's mandatory for all users to reset their passwords by 08/10/2025. This is a precautionary measure to strengthen our platform's security and protect your data. Please update your password from your profile settings. If you have any trouble, please contact our support for assistance. We apologize for any inconvenience and thank you for your understanding.",
    createdBy: 590,
    createdOn: "2025-08-03T16:45:00.000Z",
    lastUpdatedBy: 590,
    submittedById: 576,
    lastUpdatedOn: "2025-08-03T16:45:00.000Z",
  },
  {
    id: 6,
    title: "API Documentation Update",
    type: ANNOUNCEMENT_TYPE.UPDATE,
    message:
      "Good news for our API users! We have updated our API documentation to help you integrate with our platform more effectively. The documentation now includes more examples, clearer explanations, and a new FAQ section to answer common enquiries. We always aim to provide a seamless developer experience and we believe this update will greatly assist you in your integration processes!",
    createdBy: 523,
    createdOn: "2025-08-02T08:20:00.000Z",
    lastUpdatedBy: 523,
    submittedById: 523,
    lastUpdatedOn: "2025-08-02T08:20:00.000Z",
  },
  {
    id: 7,
    title: "Community Event",
    type: ANNOUNCEMENT_TYPE.EVENT,
    message:
      "We are excited to announce our upcoming virtual meetup on 08/25/2025. This event allows us to connect with you, our valued users, and we would love to have you join! We will be discussing upcoming features, revealing some behind-the-scenes insights, and listening to your valuable feedback. It's a great opportunity to interact with our team and suggest improvements. Follow the link from the dashboard to join the event.",
    createdBy: 576,
    createdOn: "2025-08-01T13:10:00.000Z",
    lastUpdatedBy: 576,
    submittedById: 590,
    lastUpdatedOn: "2025-08-01T13:10:00.000Z",
  },
  {
    id: 8,
    title: "Bug Fix Release",
    type: ANNOUNCEMENT_TYPE.BUG_FIX,
    message:
      "We're committed to delivering a flawless user experience, and that's why we're excited to announce a new release focused on bug fixes. Over the past few weeks, we've resolved several issues users were facing. We tested everything meticulously to ensure a smooth experience for you. We also enhanced our platform's overall stability and performance. We appreciate your patience and support while we continually work to improve.",
    createdBy: 541,
    createdOn: "2025-07-31T10:00:00.000Z",
    lastUpdatedBy: 541,
    submittedById: 555,
    lastUpdatedOn: "2025-07-31T10:00:00.000Z",
  },
  {
    id: 9,
    title: "Performance Optimization",
    type: ANNOUNCEMENT_TYPE.PERFORMANCE,
    message:
      "To provide you with a smoother and faster app experience, we're happy to announce that starting from 08/09/2025, you'll notice a significant improvement in load times. After hearing feedback from our users, we prioritized performance optimization, and we believe that this update makes good on that promise. Thanks for bearing with us while we carried out this important work!",
    createdBy: 568,
    createdOn: "2025-07-30T15:25:00.000Z",
    lastUpdatedBy: 568,
    submittedById: 587,
    lastUpdatedOn: "2025-07-30T15:25:00.000Z",
  },
  {
    id: 10,
    title: "New Support Channel",
    type: ANNOUNCEMENT_TYPE.SUPPORT,
    message:
      "We always aim to provide prompt and efficient support to our users. That's why we're introducing our new live chat feature to assist you in real-time. Now you don't have to wait for email responses to get solutions for your issues. Just head over to our support page and start a chat with our friendly support specialists. Hope this new support channel enhances your experience with our platform!",
    createdBy: 599,
    createdOn: "2025-07-29T12:40:00.000Z",
    lastUpdatedBy: 599,
    submittedById: 512,
    lastUpdatedOn: "2025-07-29T12:40:00.000Z",
  },
  {
    id: 11,
    title: "Terms of Service Update",
    type: ANNOUNCEMENT_TYPE.POLICY,
    message:
      "We've updated our Terms of Service to better explain our relationship with users and to cover new features. We recommend that you read these updated terms and ensure that you understand the agreement you're entering into by using our services. Your continued use of our platform will signify your acceptance of these new terms. We thank you for your understanding and for being part of our user community.",
    createdBy: 517,
    createdOn: "2025-07-28T09:50:00.000Z",
    lastUpdatedBy: 517,
    submittedById: 534,
    lastUpdatedOn: "2025-07-28T09:50:00.000Z",
  },
];
